export { default as HellFire } from './component'
